
let TestModel = require('@/mixins/Forms/2022/TestModel')

module.exports = {

    mixins: [TestModel],

    methods:{

        initTest() {

            // Construction Inspection
            this.form.construction_inspection.result = true;
            _.each(this.form.construction_inspection.rows, row => {
                if (!row.answer) {
                    this.form.construction_inspection.result = false;
                }
            })

            // Functional Test
            this.form.functional_test.result = true;
            _.each(this.form.functional_test.rows, row => {
                if (row.type == 'Boolean' && !row.answer) {
                    this.form.functional_test.result = false;
                }
            })

            // Test Restult
            this.form.testResult =  (this.form.construction_inspection.result &&  this.form.functional_test.result);
        },
    },
}
